import React from "react";
import { Link, useSearchParams } from "react-router-dom";
import { XCircle } from "lucide-react";

const BookingCancel = () => {
  const [sp] = useSearchParams();
  const bid = sp.get("booking_id");
  return (
    <div className="max-w-2xl mx-auto px-6 py-16 text-center" data-testid="booking-cancel-page">
      <XCircle className="w-14 h-14 mx-auto text-amber-500" />
      <h1 className="mt-4 font-display font-bold text-[#0B2B62] text-2xl">Pagamento cancelado</h1>
      <p className="mt-2 text-slate-600">Sua reserva {bid ? `#${bid.slice(0,8)} ` : ""}foi cancelada. Se preferir, escolha outro horário ou outro profissional.</p>
      <div className="mt-6 flex justify-center gap-3">
        <Link to="/profissionais" className="inline-flex items-center px-5 py-3 rounded-md bg-emerald-700 hover:bg-emerald-800 text-white text-sm font-bold">Voltar à vitrine</Link>
        <Link to="/" className="inline-flex items-center px-5 py-3 rounded-md border border-slate-300 hover:bg-slate-50 text-sm font-semibold">Início</Link>
      </div>
    </div>
  );
};

export default BookingCancel;
